import * as React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

type ControlProps = {
  id?: string;
  "aria-invalid"?: boolean | "true" | "false";
  "aria-describedby"?: string;
};

export interface FormFieldProps {
  id: string;
  label: string;
  description?: string;
  error?: string;
  className?: string;
  children?: React.ReactElement<ControlProps>;
  inputProps?: React.ComponentProps<typeof Input>;
}

export function FormField({
  id,
  label,
  description,
  error,
  className,
  children,
  inputProps,
}: FormFieldProps) {
  const errorId = error ? `${id}-error` : undefined;
  const descriptionId = description ? `${id}-description` : undefined;
  const describedBy = [descriptionId, errorId].filter(Boolean).join(" ") || undefined;

  return (
    <div className={cn("grid gap-1.5", className)}>
      <Label htmlFor={id} className="text-[12px] text-ink-500">
        {label}
      </Label>
      {children ? (
        React.cloneElement(children, {
          id,
          "aria-invalid": error ? "true" : undefined,
          "aria-describedby": describedBy,
        })
      ) : (
        <Input
          id={id}
          aria-invalid={error ? "true" : undefined}
          aria-describedby={describedBy}
          {...inputProps}
        />
      )}
      {description ? (
        <p id={descriptionId} className="text-[12px] text-ink-500">
          {description}
        </p>
      ) : null}
      {error ? (
        <p id={errorId} role="alert" className="text-[12px] text-vroom-red">
          {error}
        </p>
      ) : null}
    </div>
  );
}
